import React, { useRef, useState } from 'react'
import { useAddNewUserappMutation } from './UnitSlice';

function AddUnit() {

    const [addNewUserapp, { isLoading }] = useAddNewUserappMutation()
    const [addUserApp, setAddUserApp] = useState({ name: "", });
    const refClose = useRef(null);


    const handleChange = (e) => setAddUserApp({ ...addUserApp, [e.target.name]: e.target.value });

    const handleClick = async (e) => {
        e.preventDefault();
        try {
            const xyz = await addNewUserapp({ name: addUserApp.name, }).unwrap()
            setAddUserApp({ name: "", })
            refClose.current.click()
        }
        catch (e) {
            console.error(e)
        }
    }

    return (
        <>
            <button type="button" className="Add_button bg-left-navabr  text-light  btn btn-secondary" data-bs-toggle="offcanvas" data-bs-target="#depOffCanvas" aria-controls="depOffCanvas"><i className="fa fa-plus" aria-hidden="true"></i> Add Unit</button>

            <div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="1" id="depOffCanvas" aria-labelledby="depOffCanvas">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvas1Label">Add Unit</h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref={refClose}></button>
                </div>
                <div className="offcanvas-body">
                    <div>
                        <form className="row g-3">
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="name"
                                    value={addUserApp.name}
                                    onChange={handleChange}
                                    placeholder=""
                                    autoComplete="off"
                                    required
                                />
                            </div>

                            {/* <div className="col-md-12 text-left">
                                <label htmlFor="type" className="form-label font-weight-bold">
                                    Active
                                </label>

                                <select className="form-select" id="active" name="active"
                                    value={addUserApp.active} onChange={handleChange}
                                    required>
                                    <option value="" defaultValue>Select</option>
                                    <option value="1" defaultValue>Yes</option>
                                    <option value="0" defaultValue>No</option>
                                </select>
                            </div> */}
                            <div className="col-md-12">
                                <button type="submit" className="btn btn-ff9b44 btn-block btn-round"
                                    onClick={handleClick}
                                    disabled={!(addUserApp.name)}
                                >
                                    {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddUnit;